import React, { useEffect, useState } from 'react'
import { Cookies } from 'react-cookie'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/analytics'
import Routes from './Routes'
import CookieBanner from './features/utils/views/CookieBanner'

function App() {
  const [usuarioAceitouCookie, setUsuarioAceitouCookie] = useState(false)
  const [exibirCookieBanner, setExibirCookie] = useState(false)
  const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID,
    databaseURL: process.env.REACT_APP_DATABASE_URL,
  }

  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig)
    firebase.analytics()
    firebase.database()
  } else {
    firebase.app()
  }

  useEffect(() => {
    setTimeout(() => setExibirCookie(true), 2500)
    const cookie = new Cookies()
    const dataCookieAceito = cookie.get('dfDataCookiesAceito')

    if (dataCookieAceito) {
      setUsuarioAceitouCookie(true)
    }
  })

  return (
    <div>
      <Routes firebase={firebase} />
      {!usuarioAceitouCookie ? (
        <CookieBanner
          visivel={exibirCookieBanner}
          usuarioAceitou={setUsuarioAceitouCookie}
        />
      ) : null}
    </div>
  )
}

export default App
